import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Button, Stack } from '@mui/material';
import { TextFieldCDS } from '@sharedCR/coreDesignSystem/form';
import PropTypes from 'prop-types';

import useForm from 'hooks/useForm';

import { closeDialogAction, showMessageAction } from 'store/global/actions';
import { withdrawLoanExceptionAction } from 'store/loanExceptions/actions';

import { noValidateInputProps } from '../Exceptions.constants';
import { ExceptionsTestIds } from '../Exceptions.testIds';

import { INITIAL_FORM_STATE } from './WithdrawForm.constants';
import { formStackSx } from './WithdrawForm.styles';

const WithdrawForm = ({ exception }) => {
  const dispatch = useDispatch();
  const { form, handleChange } = useForm(INITIAL_FORM_STATE);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = useCallback(async () => {
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    try {
      await dispatch(
        withdrawLoanExceptionAction({
          id: exception.id,
          payload: { note: form.note.trim() || null },
        }),
      );

      dispatch(closeDialogAction());
    } catch (error) {
      dispatch(
        showMessageAction({
          variant: 'error',
          message: error?.response?.data?.message || 'Could not withdraw exception',
        }),
      );
    } finally {
      setIsSubmitting(false);
    }
  }, [dispatch, exception.id, form.note, isSubmitting]);

  return (
    <Stack sx={formStackSx}>
      <TextFieldCDS
        multiline
        dataTestId={ExceptionsTestIds.WITHDRAW_REASON_INPUT}
        inputProps={noValidateInputProps}
        label="Withdraw reason"
        minRows={3}
        name="note"
        value={form.note}
        onChange={handleChange}
      />

      <Button
        color="warning"
        data-testid={ExceptionsTestIds.WITHDRAW_BUTTON}
        disabled={isSubmitting}
        variant="contained"
        onClick={onSubmit}
      >
        Withdraw
      </Button>
    </Stack>
  );
};

WithdrawForm.propTypes = {
  exception: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

export default WithdrawForm;
